import { useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import eye from "../assets/icons/eye-fill.svg";
import eyeslash from "../assets/icons/eye-slash-fill.svg";

function Toolbar() {
  const { file, grid, setGrid } = useContext(AppContext);

  return (
    // eslint-disable-next-line
    <toolbar>
      <label htmlFor="showGrid">Grid</label>
      <button id="showGrid" onClick={() => setGrid(!grid)}>
        {grid === true ? (
          <img className="icon" alt="hide grid" src={eyeslash} />
        ) : (
          <img className="icon" alt="show grid" src={eye} />
        )}
      </button>{" "}
      <span>
        {file !== undefined &&
        file.currentView in file.models &&
        file.models[file.currentView] !== undefined
          ? file.models[file.currentView].name +
            "." +
            file.models[file.currentView].format
          : ""}
      </span>
    </toolbar>
  );
}

export default Toolbar;
